import { render, staticRenderFns } from "./SingleDND.vue?vue&type=template&id=5bd1f208"
import script from "./SingleDND.vue?vue&type=script&lang=js"
export * from "./SingleDND.vue?vue&type=script&lang=js"
import style0 from "./SingleDND.vue?vue&type=style&index=0&id=5bd1f208&prod&lang=css"


/* normalize component */
import normalizer from "!../../cortex/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports